import React from "react";
import styled from "styled-components";
import { Row, Column, Text } from "../theme/index";
import logo from "../../assets/logo.png";
import footerImg from "../../assets/footer.jpg";

const Img = styled.img`
  width: 225px;
`;

const Wrapper = styled.div`
    height: 40vh;
    min-height: 380px;
    width: 100%;
    background: url('${footerImg}');
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media (max-width: 1100px) {
      height: 100%;
      padding: 2em 0;
      margin: 0 auto;
    }
`;

const StyledRow = styled(Row)`
  align-items: center;
  justify-content: space-around;
  width: 100%;
  @media (max-width: 1100px) {
    flex-direction: column;
  }
`;

// const StyledTextRow = styled(Row)`
//   @media (max-width: 1100px) {
//     width: 100%;
//   }
// `;

const StyledColumn = styled(Column)`
  width: 40%;
  @media (max-width: 1100px) {
    width: 95%;
  }
`;

export default function Footer() {
  return (
    <Wrapper>
      <StyledRow>
        <StyledColumn>
          <Img src={logo} alt="AchieveCE Logo" />
          <Text textalign="left" white>
            At AchieveCE, we strive to make completing your continuing education
            clear, simple and enjoyable. Why should CE have to be a pain? Choose
            AchieveCE to make your continuing education experience a great one.
          </Text>
        </StyledColumn>
        <StyledColumn>
          <Row>
            {/* <Button className="drift-open-chat">SUPPORT</Button> */}
            <Text white>
              <a style={{ color: "#fff" }} href="mailto:info@achievecre.com">
                info@achievece.com
              </a>
            </Text>
          </Row>
          {/* <Formik
              initialValues={{ email: "Email for support" }}
              onSubmit={values => console.log(values)}
              render={({
                errors,
                values,
                handleSubmit,
                handleChange,
                handleBlur
              }) => (
                <Row alignitems="center">
                  <Input
                    footer
                    values={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  <I onClick={handleSubmit} className="fas fa-paper-plane" />
                </Row>
              )}
            /> */}
          {/* <Row margin="1em 0 0 0">
            <I social className="fab fa-facebook-f" />
            <I social className="fab fa-instagram" />
            <I social className="fab fa-twitter" />
          </Row> */}
        </StyledColumn>
      </StyledRow>
      <StyledRow>
        <Text white>Accreditation Number: #50-20641</Text>
        <Text white>Academy of General Dentistry/PACE Provider #386503</Text>
        <Text white>Copyright 2018 - AchieveCE</Text>
      </StyledRow>
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/shared/Footer.jsx